
import {defineComponent} from 'vue';

export default defineComponent({
  name: 'oxd-loading-spinner',

  props: {
    withContainer: {
      type: Boolean,
      default: true,
    },
  },

  computed: {
    classes(): object {
      return {
        'oxd-loading-spinner-container': this.withContainer,
        'oxd-loading-spinner-container--block': !this.withContainer,
      };
    },
  },
});
